import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalDataService } from '../common/global-data.service';
import { lastValueFrom } from 'rxjs';
import { API_ENDPOINT, GLOBAL_DATA_KEY } from '@core/configs';
import { ApiService, SessionStorageService } from '@core/services/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserDashboardService {
  private userInfoSubject = new BehaviorSubject<any>(null);
  public userInfo$: Observable<any> = this.userInfoSubject.asObservable();

  constructor(private readonly globalDataService: GlobalDataService, private httpClient: HttpClient, private readonly http: ApiService,private sessionStorageService: SessionStorageService,) {}
  triggerUserUpdate(data: any) {
    this.userInfoSubject.next(data);
  }
  async getSummaryInformationByObjcd(screenCd: string, userRequest:any, totalDayGetHandover:number) {
    const corpPrefix = this.globalDataService.get(GLOBAL_DATA_KEY.corpPrefix);
    const officeCd = this.globalDataService.get(GLOBAL_DATA_KEY.officeCd);

    const keys = {
      "CorpPrefix": corpPrefix,
      "OfficeCd": officeCd,
      "ScreenCd": screenCd
    };
    const request = {
      keys,
      userRequest,
      totalDayGetHandover
    }

    const url = `${API_ENDPOINT.userDashboard.getUser}`;
    return await lastValueFrom(this.http.post(url, request));
  }

  getImageBlob(objcd: string, noteid: string, modified: string){
    const url = API_ENDPOINT.userDashboard.getImage + `/${objcd}/${noteid}/${modified}`;
    return this.httpClient.get(url, { responseType: 'blob' });
  }

  async getImageMetaData(objcd: string, noteIds: string[]) {
    const url = `${API_ENDPOINT.userDashboard.getMetaData}/${objcd}`;
    return await lastValueFrom(this.http.post(url, noteIds));
  }

  getVideoUrl(objcd: string, noteId: string, officeCd: string) {
    const url = `${API_ENDPOINT.userDashboard.getUserVideo}/${objcd}/${noteId}/${officeCd}`;
    return this.httpClient.get(url, { responseType: 'blob' });
  }
}
